module.exports = "/cabinet/img/header-logo.535b15d0.svg";